import { j as a } from "./index.es9.js";
const l = ({
  header: s,
  langAriaSteps: e,
  ...n
}) => /* @__PURE__ */ a.jsxs("button", { className: "bl-accordion__header-button", tabIndex: 0, ...n, children: [
  /* @__PURE__ */ a.jsx("div", { className: "bl-accordion__icon", "aria-hidden": "true", children: /* @__PURE__ */ a.jsx("i", { className: "bl-icon--chevron-down bl-icon--small" }) }),
  e && /* @__PURE__ */ a.jsxs("span", { className: "bl-sr-only", children: [
    e,
    ":"
  ] }),
  /* @__PURE__ */ a.jsx("div", { className: "bl-accordion__header-content", children: s })
] });
export {
  l as default
};
//# sourceMappingURL=index.es120.js.map
